const statsTypes = {
  RESET_DAILY_CAMPAIGN_INSIGHT_STATE: 'RESET_DAILY_CAMPAIGN_INSIGHT_STATE',
  DAILY_CAMPAIGN_INSIGHTS: {
    REQUEST: 'DAILY_CAMPAIGN_INSIGHTS.REQUEST',
    SUCCESS: 'DAILY_CAMPAIGN_INSIGHTS.SUCCESS',
    FAILURE: 'DAILY_CAMPAIGN_INSIGHTS.FAILURE',
  },
};

export default statsTypes;
